import { LOADING } from '../types';
import { LoadingAction } from '../../../config/interface';

export default function setLoading(isLoading: boolean): LoadingAction {
  return {
    type: LOADING,
    isLoading,
  };
}
